// Universal Form Element
const elementList = document.querySelectorAll(".universal-form-element");

if (elementList.length > 0) {
    elementList.forEach((item) => {
        let tag = item.getAttribute("data-tag");
        tag = tag.trim();
        const newElement = document.createElement(tag);
        newElement.innerHTML = item.innerHTML;
        for (let i = 0; i < item.attributes.length; i++) {
            const attr = item.attributes[i];
            newElement.setAttribute(attr.name, attr.value);
        }
        item.parentNode.replaceChild(newElement, item);
    });
}

// Delivery Form Content
const deliveryRadioElements = document.querySelectorAll(".delivery-radio-input");
const deliveryContentElements = document.querySelectorAll(".delivery-content");
function triggerDeliveryRadioContent(e) {
    let tempData = e.target.getAttribute("data-delivery-content");
    deliveryContentElements.forEach((item) => {
        item.classList.add("hidden");
    });

    deliveryContentElements.forEach((item) => {
        if (item.getAttribute("data-delivery-content-name") === tempData) {
            item.classList.remove("hidden");
        } else {
            item.classList.add("hidden");
        }
    });
}

if (deliveryRadioElements.length > 0 && deliveryContentElements.length > 0) {
    if (deliveryRadioElements.length > 0) {
        deliveryRadioElements.forEach((item) => {
            item.addEventListener("change", (e) => triggerDeliveryRadioContent(e));
        });
    }
}

// Billing Form Content
const BillingRadioElements = document.querySelectorAll(".billing-radio-input");
const BillingContentElements = document.querySelectorAll(".billing-content");

function triggerBillingRadioContent(e) {
    let tempData = e.target.getAttribute("data-billing-content");
    BillingContentElements.forEach((item) => {
        item.classList.add("hidden");
    });

    BillingContentElements.forEach((item) => {
        if (item.getAttribute("data-billing-content-name") === tempData) {
            item.classList.remove("hidden");
        } else {
            item.classList.add("hidden");
        }
    });
}

if (BillingRadioElements.length > 0 && BillingContentElements.length > 0) {
    if (BillingRadioElements.length > 0) {
        BillingRadioElements.forEach((item) => {
            item.addEventListener("change", (e) => triggerBillingRadioContent(e));
        });
    }
}

function sortCountrySelect(countryInput) {
    if (countryInput) {
        const countryList = countryInput.querySelectorAll("option");
        const countryListArray = Array.prototype.slice.call(countryList);

        countryListArray.sort(function (a, b) {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
        });

        countryListArray.forEach((item) => {
            countryInput.appendChild(item);
        });
    }
}

// Alternate Address
const deliveryAdressRadioElements = document.querySelectorAll(
    "input[name='--form[addressGrid_col_delivery_input_radio]']"
);
const deliveryAdressContentElement = document.querySelector(".alternateAddressContainer");
if (deliveryAdressRadioElements.length > 0 && deliveryAdressContentElement) {
    deliveryAdressRadioElements.forEach((item) => {
        item.addEventListener("change", (e) => {
            if (e.target.checked && e.target.value == "Andere") {
                deliveryAdressContentElement.classList.remove("hidden");
            } else {
                deliveryAdressContentElement.classList.add("hidden");
            }
        });
    });
}

const countryInputAddress = document.querySelector("#form-addressGrid_col_Country_input_select");
const countryInputVet = document.querySelector("#form-vetInfoGrid_col_Country_input_select");
const associationInputMare = document.querySelector("#form-mareInfoGrid_col_BreedingAssociation_input_select");

sortCountrySelect(countryInputAddress);
sortCountrySelect(countryInputVet);
sortCountrySelect(associationInputMare);
